export default {
  namespaced: true,
  state: {
    colorsConfig: {
      bet_house: '',
      main_logo: '',
      secondary_logo: '',
      show_logo: false,
      url_base: '',
    },
  },
  getters: {},
  mutations: {
    setColorsConfig(state, colorsConfig) {
      state.colorsConfig = colorsConfig;
    },
  },
  actions: {},
};
